/** The HTML owns a visible fallback before the application bundle arrives.
 * This small entry point preserves it through download and renderer failures. */
export async function startApplication(load: () => Promise<unknown>): Promise<void> {
  const screen = document.getElementById("startup");
  let failed = false;
  const detail = (message: string) => { const target = document.getElementById("startup-detail"); if (target) target.textContent = message; };
  const fail = (error: unknown) => {
    failed = true;
    const message = error instanceof Error ? error.message : String(error);
    detail(/webgl|graphics context/i.test(message)
      ? "Your browser could not start the 3D graphics. Close other tabs and reload to try again."
      : /fetch|network|load|import/i.test(message)
        ? "The application download did not finish. Check your connection and reload to try again."
        : "World Next could not start. Reload to try again.");
    const root = document.getElementById("root"); if (root) root.hidden = true;
    const diagnostics = document.getElementById("startup-error");
    if (diagnostics) { diagnostics.hidden = false; const output = diagnostics.querySelector("pre"); if (output) output.textContent = message.slice(0, 1000); }
  };
  const onError = (event: ErrorEvent) => fail(event.error ?? event.message);
  const onRejection = (event: PromiseRejectionEvent) => fail(event.reason);
  window.addEventListener("error", onError);
  window.addEventListener("unhandledrejection", onRejection);
  const timer = setTimeout(() => { if (!failed) detail("The download is taking longer than usual. You can keep waiting or reload to try again."); }, 15_000);
  try {
    await load();
    if (!failed) await new Promise<void>(resolve => requestAnimationFrame(() => resolve()));
    if (!failed) screen?.remove();
  } catch (error) { fail(error); }
  finally {
    clearTimeout(timer);
    window.removeEventListener("error", onError);
    window.removeEventListener("unhandledrejection", onRejection);
  }
}
